<div [ngClass]="menuIsOpen ? 'relative': ''" class="lg:h-screen lg:grid lg:grid-cols-6">
  <section [ngClass]="menuIsOpen ? 'sticky left-0 top-0 border-r': ''" id="menu" class="lg:col-span-1 hidden lg:block">
    <app-menu
      (Clicked)="selectCurrentRoute($event)"
      (IsClicked)="closeMenu()"
      [activeRoute]="activeRoute"
    ></app-menu>
  </section>
  <main class="col-span-6 lg:col-span-5">
    <div class="w-full">
      <app-header></app-header>
    </div>
    <div>
      <router-outlet (activate)="changeOfRoutes()"></router-outlet>
    </div>
  </main>
</div>
<div class="lg:hidden block fixed right-4 bottom-4" (click)="openMenu()">
  <img
    draggable="false"
    class="h-20 cursor-pointer overflow-hidden"
    src="assets/svg/burger-menu.svg"
    alt="Menu"
  />
</div>
